import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { Button } from '@/components/button';
import { TextInput } from '@/components/inputs';
import { tv } from '@/utils/styles';

export interface CreateShipmentListTabFormProps {
  onSubmit: (data: CreateShipmentListTabFormData) => void;
  initialValue?: CreateShipmentListTabFormData;
}

export interface CreateShipmentListTabFormData {
  label: string;
}

const schema = yup.object().shape({
  label: yup.string().required('Label is required'),
});

const CreateShipmentTabForm = ({ onSubmit, initialValue }: CreateShipmentListTabFormProps) => {
  const {
    control,
    handleSubmit,

    formState: { errors, isSubmitting },
  } = useForm<CreateShipmentListTabFormData>({
    defaultValues: initialValue,
    resolver: yupResolver(schema),
  });

  const { base } = styles();

  return (
    <form className={base()} onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="label"
        render={({ field }) => {
          return (
            <TextInput
              placeholder="e.g. Air shipments"
              className="flex-1"
              {...field}
              disabled={isSubmitting}
              errors={errors}
              label="Name"
            />
          );
        }}
      />

      <Button type="submit" isLoading={isSubmitting} disabled={isSubmitting}>
        Save
      </Button>
    </form>
  );
};

const styles = tv({
  slots: {
    base: 'flex items-end gap-2',
  },
});

export default CreateShipmentTabForm;
